import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
}: EmptyStateProps) {
  const actionClasses =
    'px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer';

  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-4">
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-5">
        <i className={`${icon} text-3xl`} />
      </div>
      <h3 className="font-heading font-bold text-lg text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>}
      {actionLabel && actionTo && (
        <Link to={actionTo} className={`mt-6 ${actionClasses}`}>
          {actionLabel}
        </Link>
      )}
      {actionLabel && !actionTo && onAction && (
        <button type="button" onClick={onAction} className={`mt-6 ${actionClasses}`}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}